import styled from 'styled-components';

export const Wrapper = styled.div<{ hasPanel?: boolean }>`
  display: flex;
  flex-direction: row;
  height: 100%;
  min-height: 0;
  justify-content: center;
  width: 100%;
  margin-left: ${({ hasPanel }) => (hasPanel ? 160 : 0)}px;

  @media screen and (max-width: 1366px) {
    margin-left: 0px;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
  max-width: 800px;
  width: calc(100% - 618px);

  @media screen and (max-width: 1920) {
    max-width: 700px;
  }

  @media screen and (max-width: 1440px) {
    max-width: 650px;
  }

  @media screen and (max-width: 1366px) {
    width: calc(100%);
  }
`;

export const Header = styled.div`
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: transparent;
  border-bottom: none;
`;

export const Title = styled.h3`
  color: ${({ theme }) => theme.colorPalette.grey.grey7};
  font-size: ${({ theme }) => theme.fontSizePalette.xLarge};
  margin-bottom: 0;
`;

export const SettingsPanelContainer = styled.div`
  height: 100%;
`;
